import { VictoryTheme } from 'victory'

const victoryTheme = {
  ...VictoryTheme,
  fontFamily: "'Roboto',sans-serif",
  axis: {
    style: {
      grid: {
        fill: 'none',
        stroke: 'none',
        pointerEvents: 'painted'
      },
      ticks: {
        fill: 'transparent',
        size: 1,
        stroke: 'transparent'
      }
    }
  }
}

export default victoryTheme



// WEBPACK FOOTER //
// ./src/config/victoryTheme.js